import PronunciationStatusApiUtils from '../utils/api/pronunciation';
import Collection from '../utils/Collection';

import { addMessage as addFlashMessage } from './flash';
import { hide as hideModal } from './modal';

export const FETCH_MY_PRONUNCIATION_STATUSES_SENT =
  'FETCH_MY_PRONUNCIATION_STATUSES_SENT';
export const FETCH_MY_PRONUNCIATION_STATUSES_SUCCEEDED =
  'FETCH_MY_PRONUNCIATION_STATUSES_SUCCEEDED';
export const FETCH_MY_PRONUNCIATION_STATUSES_FAILED =
  'FETCH_MY_PRONUNCIATION_STATUSES_FAILED';
export const FETCH_PRONUNCIATION_STATUSES_SENT =
  'FETCH_PRONUNCIATION_STATUSES_SENT';
export const FETCH_PRONUNCIATION_STATUSES_SUCCEEDED =
  'FETCH_PRONUNCIATION_STATUSES_SUCCEEDED';
export const FETCH_PRONUNCIATION_STATUSES_FAILED =
  'FETCH_PRONUNCIATION_STATUSES_FAILED';
export const UPDATE_PRONUNCIATION_STATUSES_SENT =
  'UPDATE_PRONUNCIATION_STATUSES_SENT';
export const UPDATE_PRONUNCIATION_STATUSES_SUCCEEDED =
  'UPDATE_PRONUNCIATION_STATUSES_SUCCEEDED';
export const UPDATE_PRONUNCIATION_STATUSES_FAILED =
  'UPDATE_PRONUNCIATION_STATUSES_FAILED';

export function fetchMineSent() {
  return { type: FETCH_MY_PRONUNCIATION_STATUSES_SENT };
}

export function fetchMineSucceeded(data) {
  return {
    type: FETCH_MY_PRONUNCIATION_STATUSES_SUCCEEDED,
    payload: data,
  };
}

export function fetchMineFailed(error) {
  return {
    type: FETCH_MY_PRONUNCIATION_STATUSES_FAILED,
  };
}

export function fetchMine(userId) {
  return (dispatch) => {
    dispatch(fetchMineSent());
    return PronunciationStatusApiUtils.fetchByStudentId(userId).then(
      (data) => dispatch(fetchMineSucceeded(data)),
      (error) => dispatch(fetchMineFailed(error)),
    );
  };
}

export function fetchSent() {
  return { type: FETCH_PRONUNCIATION_STATUSES_SENT };
}

export function fetchSucceeded(data) {
  return {
    type: FETCH_PRONUNCIATION_STATUSES_SUCCEEDED,
    payload: data,
  };
}

export function fetchFailed(error) {
  return {
    type: FETCH_PRONUNCIATION_STATUSES_FAILED,
  };
}

export function fetchByStudentId(id) {
  return (dispatch) => {
    dispatch(fetchSent());
    return PronunciationStatusApiUtils.fetchByStudentId(id).then(
      (data) => dispatch(fetchSucceeded(data)),
      (error) => dispatch(fetchFailed(error)),
    );
  };
}

export function updateManySent() {
  return { type: UPDATE_PRONUNCIATION_STATUSES_SENT };
}

export function updateManySucceeded(data, pronState) {
  const statuses = Collection.updateMany(
    pronState.statuses,
    data.changed_statuses,
  );
  return {
    type: UPDATE_PRONUNCIATION_STATUSES_SUCCEEDED,
    payload: { statuses },
  };
}

export function updateManyFailed(error) {
  return { type: UPDATE_PRONUNCIATION_STATUSES_FAILED };
}

export function updateMany(studentId, changedStatuses) {
  return (dispatch, getState) => {
    // dispatch(updateManySent());
    return PronunciationStatusApiUtils.updateMany(
      studentId,
      changedStatuses,
    ).then(
      (data) => {
        dispatch(hideModal());
        dispatch(
          addFlashMessage('Successfully updated the summary.', {
            type: 'success',
            autoDisappear: true,
            sticky: true,
          }),
        );
        const state = getState();
        const pronState = state.studentPronunciation;
        dispatch(updateManySucceeded(data, pronState));
      },
      (error) => {
        dispatch(
          addFlashMessage(error.message, {
            autoDisappear: true,
            type: 'error',
            sticky: true,
          }),
        );
        dispatch(updateManyFailed(error));
      },
    );
  };
}
